// Use the appointment type's increment anchored to each offered working period.
// The visual grid interval deliberately plays no part in choosing a start.
export function snapBookingStart({ requestedStart, duration, increment, windows, scheduleIds, serviceCategoryId, now = Date.now() }) {
  if (!(increment > 0) || !(duration > 0)) return null;
  const candidates = windows.flatMap((window) => {
    if (window.active === false || !scheduleIds.includes(window.scheduleId) || !window.serviceCategoryIds?.includes(serviceCategoryId)) return [];
    const start = Date.parse(window.startsAt);
    const end = Date.parse(window.endsAt);
    const last = Math.floor((end - start - duration) / increment);
    if (!Number.isFinite(start) || !Number.isFinite(end) || last < 0) return [];
    const index = Math.max(0, Math.min(last, Math.round((requestedStart - start) / increment)));
    const candidate = start + index * increment;
    // Do not jump across a break or to a distant working period.
    return candidate > now && Math.abs(candidate - requestedStart) <= increment / 2 ? [candidate] : [];
  });
  return candidates.sort((a, b) => Math.abs(a - requestedStart) - Math.abs(b - requestedStart) || a - b)[0] ?? null;
}
